<script lang="ts">
  import "../app.css";

  import Footer from "../components/Footer/Footer.svelte";
  import ThemeProvider from "../themes/ThemeProvider.svelte";
</script>

<svelte:head>
  <title>{import.meta.env.VITE_APP_TITLE}</title>
</svelte:head>

<svelte:window on:resize={() => window.oprt?.dispatchContentSizeChanged?.()} />

<ThemeProvider>
  <slot />
  <Footer />
</ThemeProvider>
